import apiClient from './client';

export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024; // 50MB client pre-check UX

/**
 * Project API Client Layer
 * Encapsulates all backend operations for Mission 10 Persistent Projects & Mission 11 Auth.
 */

export const listProjects = async () => {
  const response = await apiClient.get('/projects');
  return response.data || [];
};

export const getProject = async (projectId) => {
  const response = await apiClient.get(`/projects/${projectId}`);
  return response.data;
};

export const createProject = async ({ name, description, sessionId }) => {
  const payload = {
    name: name.trim(),
    description: description ? description.trim() : 'No description provided'
  };
  if (sessionId) {
    payload.session_id = sessionId;
  }
  const response = await apiClient.post('/projects', payload);
  return response.data;
};

export const updateProject = async (projectId, updates) => {
  const payload = {};
  if (updates.name !== undefined) payload.name = updates.name.trim();
  if (updates.description !== undefined) payload.description = updates.description.trim();

  const response = await apiClient.patch(`/projects/${projectId}`, payload);
  return response.data;
};

export const archiveProject = async (projectId) => {
  const response = await apiClient.post(`/projects/${projectId}/archive`);
  return response.data;
};

export const restoreProject = async (projectId) => {
  const response = await apiClient.post(`/projects/${projectId}/restore`);
  return response.data;
};

export const deleteProject = async (projectId) => {
  const response = await apiClient.delete(`/projects/${projectId}`);
  return response.data;
};

export const listFiles = async (projectId) => {
  const response = await apiClient.get(`/projects/${projectId}/files`);
  return response.data || [];
};

export const uploadFileVersion = async (projectId, file, customFilename) => {
  if (file.size > MAX_FILE_SIZE_BYTES) {
    throw new Error(`El archivo supera el lmite mximo permitido de 50MB (${(file.size / (1024 * 1024)).toFixed(2)}MB).`);
  }

  const formData = new FormData();
  formData.append('file', file);
  if (customFilename) {
    formData.append('filename', customFilename);
  }

  const response = await apiClient.post(`/projects/${projectId}/files`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const listFileVersions = async (projectId, fileId) => {
  const response = await apiClient.get(`/projects/${projectId}/files/${fileId}/versions`);
  return response.data || [];
};

export const downloadFileVersion = async (projectId, fileId, versionId) => {
  const response = await apiClient.get(`/projects/${projectId}/files/${fileId}/versions/${versionId}/content`, {
    responseType: 'blob'
  });
  return response;
};

export const listActivities = async (projectId, limit = 50) => {
  const response = await apiClient.get(`/projects/${projectId}/activities?limit=${limit}`);
  return response.data || [];
};
